let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("eoIpr")]).then(() => parcelRequire('cUH4k'));